// @ts-nocheck
import React from 'react';
import * as ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material';
import { ReactKeycloakProvider } from '@react-keycloak-fork/web';
import Keycloak from 'keycloak-js';

import themeSpec from 'utils/theme';
import './index.css';
import { config } from 'utils/config';
import store from 'store';
import router from 'router';
import LoadingDimmer from 'components/LoadingDimmer';
import persistor from 'utils/persistor';
import { setAuthClient, startSessionRefreshLoop } from 'utils/sessionRefresh';

import { LoadingProvider } from 'hooks/useLoading';

import './errors';

// eslint-disable-next-line no-console
console.log(`Teal Business frontend: ${config.env} build, version ${process.env.REACT_APP_VERSION}`);

const appOrigin = typeof window !== 'undefined' ? window.location.origin : '';
const shouldBypassAuthForE2E = process.env.REACT_APP_E2E_BYPASS_AUTH === 'true';

const createE2EKeycloakClient = () => ({
    authenticated: true,
    token: 'e2e-token',
    refreshToken: 'e2e-refresh-token',
    idToken: 'e2e-id-token',
    onReady: undefined,
    onAuthSuccess: undefined,
    onAuthError: undefined,
    onAuthRefreshSuccess: undefined,
    onAuthRefreshError: undefined,
    onAuthLogout: undefined,
    onTokenExpired: undefined,
    init: async function init() {
        this.authenticated = true;
        this.token = this.token || 'e2e-token';
        this.refreshToken = this.refreshToken || 'e2e-refresh-token';
        this.idToken = this.idToken || 'e2e-id-token';
        if (this.onReady) this.onReady(true);
        if (this.onAuthSuccess) this.onAuthSuccess();
        return true;
    },
    updateToken: async () => true,
    login: async () => true,
    logout: async () => true,
    register: async () => true,
    createRegisterUrl: () => `${appOrigin}/register`,
    clearToken: function clearToken() {
        this.token = undefined;
        this.refreshToken = undefined;
        this.idToken = undefined;
        this.authenticated = false;
    },
});

if (shouldBypassAuthForE2E) {
    persistor.setTokens({
        token: 'e2e-token',
        refreshToken: 'e2e-refresh-token',
        idToken: 'e2e-id-token',
    });
}

const { refreshToken, idToken, token } = persistor.getTokens();

const keycloak = shouldBypassAuthForE2E
    ? createE2EKeycloakClient()
    : new Keycloak(config.keycloak);

setAuthClient(keycloak);
startSessionRefreshLoop();

const initOptions = {
    onLoad: 'check-sso',
    silentCheckSsoRedirectUri: `${appOrigin}/silent-check-sso.html`,
    silentCheckSsoFallback: false,
    checkLoginIframe: false,
    refreshToken,
    idToken,
    token,
};

const root = ReactDOM.createRoot(document.getElementById('root'));

const element = (
    <LoadingProvider>
        <ReactKeycloakProvider LoadingComponent={ <LoadingDimmer /> } authClient={ keycloak } initOptions={ initOptions } onTokens={ persistor.setTokens }>
            <Provider store={ store } >
                <ThemeProvider theme={ createTheme(themeSpec) }>
                    <RouterProvider router={ router } />
                </ThemeProvider>
            </Provider>
        </ReactKeycloakProvider>
    </LoadingProvider>
);

root.render(element);
